import React from 'react'
import { Body1, ButtonText, Headline3 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import NewButton from 'components/elements/NewButton'
import styled from 'styled-components'

const ContentSection = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .index {
        font-family: var(--font-inter);
        font-weight: 650;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0px;
        color: rgba(0, 0, 0, 0.5);
    }
    h3 {
        font-family: var(--font-inter);
        font-weight: 750;
        font-size: 30px;
        line-height: 36px;
        letter-spacing: -0.4px;
        color: ${theme.colors.black};
    }
    .description {
        font-family: var(--font-inter);
        font-weight: 450;
        font-size: 17px;
        line-height: 24px;
        letter-spacing: 0.3px;
    }
`

interface UniversityFeatureEnumerationContentProps {
    title: string | JSX.Element
    description: string
    buttonText: string
    onButtonClick?: () => void
    index: number
}

const UniversityFeatureEnumerationContent: React.FC<UniversityFeatureEnumerationContentProps> = ({
    index,
    title,
    description,
    buttonText,
    onButtonClick,
}) => {
    return (
        <ContentSection>
            <Body1
                textAlign="center"
                color={theme.colors.secondarySolidDark}
                fontFamily="var(--font-inter)"
                fontWeight={400}
                className="index"
            >
                {`0${index} `}
            </Body1>
            <Headline3 color={theme.colors.black} textAlign="center" fontFamily="var(--font-inter)" fontWeight={600}>
                {title}
            </Headline3>

            <Body1
                textAlign="center"
                color={theme.colors.secondarySolidDark}
                fontFamily="var(--font-inter)"
                fontWeight={400}
                className="description"
            >
                {description}
            </Body1>

            <NewButton onClick={onButtonClick} aria-label={buttonText} isWebapp height={55} width={275}>
                <ButtonText fontSize={16} color={theme.colors.white} textAlign="center">
                    {buttonText}
                </ButtonText>
            </NewButton>
        </ContentSection>
    )
}

export default UniversityFeatureEnumerationContent
